<template>
  <wo-region v-if="salesPoint">
    <wo-layout>
      <wo-title tag-name="h3" v-t="'salespointEdit.title'" />
    </wo-layout>
    <sales-point-edit v-if="salesPoint" :value="salesPoint" :tags="tags" @input="confirm" @cancel="confirm" />
  </wo-region>
</template>

<script>

import { mapState } from 'vuex'
import { Entities } from '@/model/util'

import { salesPointRepository, salesPointTagRepository } from '@/repository/sales-point'

import { SALES_POINT } from '@/routes/sales-point'

import SalesPointEdit from '@/components/sales-point/SalesPointEdit'

export default {
  components: { SalesPointEdit },
  props: {
    salesPointId: [String, Number]
  },
  computed: mapState({
    salesPoint: state => state.salesPoint.salesPoint,
    tags: state => Entities.items(state.salesPoint.salesPointTagList)
  }),
  created () {
    this.loadSalesPoint()
  },
  watch: {
    salesPointId () {
      this.loadSalesPoint()
    }
  },
  methods: {
    loadSalesPoint () {
      this.$store.dispatch(salesPointRepository.find, { id: this.salesPointId })
      this.$store.dispatch(salesPointTagRepository.findAll, { salesPointId: this.salesPointId })
    },
    confirm () {
      this.$router.push({ name: SALES_POINT })
    }
  }
}
</script>
